'use strict';

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// /app/node_modules/math-intrinsics/isNaN.js
// module id = 1195
// module chunks = 1 2 3